import { Component, ViewChild, Input, OnChanges, SimpleChanges, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatAccordion } from '@angular/material/expansion';
import { MatTableDataSource } from '@angular/material/table';

import { TestRunViewModel } from 'src/models/testRun';
import { TestResultsTableService } from 'src/modules/start-page/services/test-results-table-service';

@Component({
	selector: 'app-start-page-table',
	templateUrl: './start-page-table.component.html',
	styleUrls: ['./start-page-table.component.scss'],
})
export class StartPageTableComponent implements OnChanges, OnInit, AfterViewInit {
	displayedColumns: string[] = ['itemNo', 'name', 'type', 'testRun.environment', 'testRun.executionTime', 'testRun.regBy', 'testRun.testRunUid'];

	dataSource;

	maxall = 10;

	@ViewChild(MatPaginator) paginator: MatPaginator;

	@ViewChild(MatSort) sort: MatSort;

	@ViewChild(MatAccordion) accordion: MatAccordion;

	@Input()
	filteredTable: TestRunViewModel[];

	@Input() StartDate: string;

	@Input() EndDate: string;

	@Input() PropertyName: string;

	@Input() PropertyValue: string;

	getTestRunByDateRunning: boolean;

	constructor(
		private router: Router,
		private testResultsTableService: TestResultsTableService,
	) {}

	ngOnInit(): void {
		this.dataSource = new MatTableDataSource<TestRunViewModel>();
		this.dataSource.sortingDataAccessor = (item, property) => {
			if (item.testRunType === 410) {
				switch (property) {
					case 'itemNo':
						return Number(item.testSpecification?.itemNo.split('-').pop() ?? 0);
					case 'name':
						return item.testSpecification.name;
					case 'type':
						return 'Test specification';
					case 'testRun.environment':
						return item.testRun.environment;
					case 'testRun.executionTime':
						return item.testRun.executionTime;
					case 'testRun.regBy':
						return item.testRun.regBy;
					case 'testRun.testRunUid':
						return item.testRun.testRunUid;
					default:
						return item[property];
				}
			} else {
				switch (property) {
					case 'itemNo':
						return Number(item.testSuite?.itemNo.split('-').pop() ?? 0);
					case 'name':
						return item.testSuite?.name;
					case 'type':
						return 'Test suite';
					case 'testRun.environment':
						return item.testRun?.environment;
					case 'testRun.executionTime':
						return item.testRun?.executionTime;
					case 'testRun.regBy':
						return item.testRun?.regBy;
					case 'testRun.testRunUid':
						return item.testRun?.testRunUid;
					default:
						return item[property];
				}
			}
		};
		// set a new filterPredicate function to be able to filter nested objects
		this.dataSource.filterPredicate = (data, filter: string) => {
			const accumulator = (currentTerm, key) => {
				return this.nestedFilterCheck(currentTerm, data, key);
			};
			const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
			const transformedFilter = filter.trim().toLowerCase();
			return dataStr.indexOf(transformedFilter) !== -1;
		};
		this.testResultsTableService.isLoadingTable.subscribe(isLoading => {
			this.getTestRunByDateRunning = isLoading;
		});
	}

	ngAfterViewInit(): void {
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.filteredTable && this.dataSource) {
			this.dataSource.data = this.filteredTable;
		}
		this.getTestRunByDateRunning = false;
	}

	private nestedFilterCheck(search, data, key) {
		if (typeof data[key] === 'object') {
			for (const k in data[key]) {
				if (data[key][k] !== null) {
					search = this.nestedFilterCheck(search, data[key], k);
				}
			}
		} else {
			search += data[key];
		}
		return search;
	}

	public applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}

	public navigateTo(row: any) {
		this.router.navigate(['/testresult/testrun/' + row.testRun.testRunUid]);
	}
}
